import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { notBlank } from "../util/ext";

const useStyles = makeStyles(theme => ({
  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },
}));

const IpAuthenticationCell = props => {
  const { authentication } = props;
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item sm={6}>
        <Box className={classes.labelAndValue}>
          <label>Min IP:</label>
          {authentication.ipMin}
        </Box>
      </Grid>

      <Grid item sm={6}>
        <Box className={classes.labelAndValue}>
          <label>Max IP:</label>
          {authentication.ipMax}
        </Box>
      </Grid>

      {notBlank(authentication.note) && (
        <Grid item sm={12}>
          <Box className={classes.labelAndValue}>
            <label>Note:</label>
            {authentication.note}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default IpAuthenticationCell;
